import 'sonner/dist/styles.css';

import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useWebsiteTheme } from '../../lib/theme';

export function Toaster(props: ToasterProps) {
  const { theme } = useWebsiteTheme();

  return (
    <Sonner
      theme={theme}
      position="top-right"
      closeButton
      richColors
      toastOptions={{
        duration: 4000,
      }}
      {...props}
    />
  );
}
